import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/pro-solid-svg-icons/faCaretUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import { MprcClickable } from "components/MprcClickable";

interface IProps {
    text?: string;
    expanded: boolean;
    onClick: () => void;
}
export const MprcCaretSwitch = ({ text, expanded, onClick }: IProps) => {
    return (
        <Grid container alignContent="center">
            <Grid>
                <MprcClickable onClick={onClick}>
                    <Typography variant="overline" component="span">
                        <span>{text}</span>
                        &nbsp;
                        <FontAwesomeIcon
                            style={{ cursor: "pointer", color: "inherit" }}
                            icon={expanded ? faCaretUp : faCaretDown}
                        />
                    </Typography>
                </MprcClickable>
            </Grid>
        </Grid>
    );
};
